function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useCallback } from "react";
import { ItemMemberLevel, useTopicButton_RemoveMemberFromTopicMutation, ItemType, useTopicButton_RequestToJoinTopicMutation } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
function useToggleRequestToJoinTopic({ memberLevel , topicId , userId , nodeId  }) {
    const showSnackbar = useSnackbar();
    const [removeMemberFromTopic] = useTopicButton_RemoveMemberFromTopicMutation({
        variables: {
            topicId,
            userId
        },
        optimisticResponse: {
            removeMemberFromTopic: {
                itemByTopicId: {
                    nodeId,
                    id: topicId,
                    type: ItemType.Topic,
                    memberLevel: null,
                    __typename: "Item"
                },
                __typename: "RemoveMemberFromTopicPayload"
            }
        }
    });
    const [requestToJoinTopic] = useTopicButton_RequestToJoinTopicMutation({
        variables: {
            topicId
        },
        optimisticResponse: {
            requestToJoinTopic: {
                itemByTopicId: {
                    nodeId,
                    id: topicId,
                    type: ItemType.Topic,
                    memberLevel: ItemMemberLevel.Pending,
                    __typename: "Item"
                },
                __typename: "RequestToJoinTopicPayload"
            }
        }
    });
    return useCallback(_asyncToGenerator(function*() {
        try {
            if (memberLevel === ItemMemberLevel.Pending) yield removeMemberFromTopic();
            else yield requestToJoinTopic();
            showSnackbar({
                message: memberLevel === ItemMemberLevel.Pending ? "Request to join cancelled" : "You asked to join"
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        memberLevel,
        removeMemberFromTopic,
        requestToJoinTopic,
        showSnackbar
    ]);
}
export default useToggleRequestToJoinTopic;
